import * as React from 'react';
import { NavLink, NavLinkRenderProps, useNavigate } from "react-router-dom";
import { AppNavLink } from './models/Utility/AppNavLink';
import { GoogleAuthProvider, signInWithPopup, User } from 'firebase/auth';
import { auth } from './firebase';

const AppNavLinks: AppNavLink[] = [
    { text: "Mahjong", path: "/mahjong" },
    { text: "Data", path: "/data" },
];

export function AppHeader(): JSX.Element {
    return (
        <header className="flex justify-around primary-light-bottom-border-strong dark-grey-background">
            <AppTitle />
            <div className="flex gap-2">
                <AppNav />
            </div>
        </header>
    );
}

function AppTitle(): JSX.Element {
    return (
        <NavLink to="/" className="link-text flex item-align-center">
            <img src="/logo192.png" alt="Logo" style={{ height: '32px' }} className="ml-2" />
            <h4 className="white-text ma-1">Tsundraki Studio</h4>
        </NavLink>
    );
}

function AppNav(): JSX.Element {
    const isActiveTab = ({ isActive }: NavLinkRenderProps): string => isActive
        ? "navlink-active-background link-text flex item-align-center"
        : "navlink-background link-text flex item-align-center";

    return (
        <nav className="flex justify-between gap-1">
            {AppNavLinks.map((link: AppNavLink, index: number): JSX.Element => {
                return (
                    <NavLink key={index} to={link.path} className={isActiveTab}>
                        <div className="mr-2 ml-2">
                            {link.text}
                        </div>
                    </NavLink>
                );
            })}
            <UserAuthButton />
        </nav>
    );
}

function UserAuthButton(): JSX.Element {
    const [user, setUser] = React.useState<User | null>(null);
    const navigate = useNavigate();

    const isActiveTab = ({ isActive }: NavLinkRenderProps): string => isActive
        ? "navlink-active-background link-text flex item-align-center"
        : "navlink-background link-text flex item-align-center";

    React.useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((currentUser) => {
            setUser(currentUser);
        });
        return () => unsubscribe();
    }, []);

    const handleLogin = async () => {
        const provider = new GoogleAuthProvider();

        try {
            await signInWithPopup(auth, provider);
        } catch (error: any) {
            if (error.code === 'auth/user-disabled') {
                navigate('/error/account-locked');
            }
            console.error("Error signing in with Google", error);
        }
    };

    if (user) {
        return (
            <NavLink to="/user/profile" className={isActiveTab}>
                <div className="ma-3">
                    <img src={user.photoURL || ""} alt="Profile" style={{ borderRadius: '50%', width: '32px', height: '32px', display: 'block' }} />
                </div>
            </NavLink>
        );
    }

    return (
        <div className="navlink-background link-text flex item-align-center" onClick={handleLogin}>
            <div className="ma-3">
                <img src="/img/UserDefaultLogo.png" alt="Login" style={{ borderRadius: '50%', width: '32px', height: '32px', display: 'block' }} />
            </div>
        </div>
    );
}
